//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { memo, useEffect, useState, useMemo } from 'react';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import Alerts from '../Alerts';
import { Container, Row, Col } from "react-bootstrap";
import { BzButton, BzChip, BzHeading, BzInputText, BzTab, BzTabs, BzToastMessage, BzModal, BzModalBody, BzToolTip } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_CATEGORIES, APP_INFO_PARAMS, DELETE_ALERT_STEP, LOCAL_STORAGE_KEYS, SET_ALERT_FIELDS, SIDE_TRAY_EXPAND_PERCENTAGE, SUCCESSFULL_DELETE_ALERET_MESSAGE, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import { AlertNameDetails, DeleteAlertConfirmModal, DeleteAlertSuccessfull } from '../../Alerts';//ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 
import { getAlerts, removeMultipleAlerts, searchAlertByDropdown, searchAlertBySymbol, setTriggerAlertCount } from '../../../redux/actions/alerts';
import { getAppInfoData, getMappedMktSegIdFromApiExchangeName } from '../../../utils/global_functions';
import ContainerFooter from './ContainerFooter';
import { toastConfig } from '../../../redux/actions/toast';//ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 
import config from "../../../config.json";

import SideAlertsFiltersModal from './SideAlertsFiltersModal';
import { handleModal, handleModalData } from '../../../redux/actions/modals';

const SideAlerts = ({ setIsExpanded, setActiveMenu, setToggleSideContainer, AlertPortfolio, isVertical = true }) => {
    const dispatch = useDispatch();
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const arrAlerts = useSelector(state => state.alerts.arrAlerts);
    const trigerredAlerts = useSelector(state => state.alerts.trigerredAlerts);
    const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);
    const [activeTab, setActiveTab] = useState('alerts');
    const [bShowDeleteCheckbox, setBShowDeleteCheckbox] = useState(false);
    const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
    const [bToggleSearchBar, setBToggleSearchBar] = useState(true);

    const [deleteAlertStep, setDeleteAlertStep] = useState(DELETE_ALERT_STEP.ALERT_SELECTION);
    const [arrSelectedDeleteAlert, setArrSelectedDeleteAlert] = useState([]);

    const modals = useSelector(state => state?.modals?.modals);//ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 
    const objFilterAlertFromModal = useSelector(state => state?.alerts?.objFilterAlertFromModal);
    const [arrAlertLogHolding, setArrAlertLogHolding] = useState([]);
    const [arrAlertHolding, setArrAlertHolding] = useState([]);
    const [propertyChange, setPropertyChange] = useState(false);
    const [isShowFilterModal, setIsShowFilterModal] = useState(false);

    const holdingScrips = useSelector(state => state.holdings.holdingsScrips);
    //Vaibhav Singh : BT-117135- 20-09-2023 : holding alerts filter


    useEffect(() => {
        if (AlertPortfolio && holdingScrips) {
            let filteredarrAlertLog = [];
            let filteredarrAlert = [];
            holdingScrips?.forEach((each) => {
                trigerredAlerts.forEach((eachalert) => {
                    if (`${eachalert.segmentId}_${eachalert.nToken}` === `${each.nMarketSegmentId}_${each?.nToken}`) {
                        filteredarrAlertLog.push(eachalert);
                    }
                });
                arrAlerts.forEach((eachalert) => {
                    if (`${eachalert.segmentId}_${eachalert.nToken}` === `${each.nMarketSegmentId}_${each?.nToken}`) {
                        filteredarrAlert.push(eachalert);
                    }
                });
            });
            setArrAlertLogHolding(filteredarrAlertLog);
            setArrAlertHolding(filteredarrAlert);
            //Vaibhav Singh : BT-117135- 20-09-2023 : holding alerts filter updated for portfolio
        }
        else {

        }
    }, [trigerredAlerts, holdingScrips, arrAlerts, AlertPortfolio, isVertical]);
    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - Start
    const arrActiveAlerts = useMemo(() => {
        setSelectAllCheckbox(false);
        if (AlertPortfolio) {
            if (activeTab === 'alerts') {
                return arrAlertHolding;
            } else {
                return arrAlertLogHolding;

            }
        } else {
            if (activeTab === 'alerts') {
                return isVertical === false ? arrAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) : arrAlerts || [];
            } else {
                return isVertical === false ? trigerredAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) : trigerredAlerts || [];

            }
        }
    }, [activeTab, arrAlertHolding, arrAlertLogHolding, arrAlerts, trigerredAlerts, AlertPortfolio, scripOverviewData, isVertical]);
    //Azeem Khan : 24-04-2024 : BT-107432 -  Breeze - Alerts - End
    useEffect(() => {
        dispatch(getAlerts(objLoginSession?.data?.user_id));
    }, [dispatch, objLoginSession?.data?.user_id]);
    const showDeleteCheckbox = () => {
        //ManasaB : 13/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - AlertLog Issue - Start
        if (activeTab === 'alerts') {
            if (AlertPortfolio) {
                if (arrAlertHolding.length > 0) {
                    setBShowDeleteCheckbox(true);
                }
            }
            else {
                if (arrAlerts.length > 0) {
                    setBShowDeleteCheckbox(true);
                }
            }
        }
        if (activeTab === 'alertlog') {
            if (AlertPortfolio) {
                if (arrAlertLogHolding.length > 0) {
                    setBShowDeleteCheckbox(true);
                }
            }
            else {
                if (trigerredAlerts.length > 0) {
                    setBShowDeleteCheckbox(true);
                }
            }
        }
        //ManasaB : 13/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - AlertLog Issue - End
    };

    useEffect(() => {
        dispatch(toastConfig({ show: false }));
    }, [activeTab, dispatch]);

    const handleSetAlertShow = () => {
        dispatch(handleModalData({ isSearchable: true }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting - Start
    const strClassName = arrSelectedDeleteAlert.length > 0 ? 'btn btn-light ms-3' : 'btn btn-outline-active ms-3';
    useEffect(() => {
        if (bShowDeleteCheckbox && AlertPortfolio) {
            // const selectedAlertsLength = AlertPortfolio ? arrAlertHolding?.length : arrAlerts?.length;

            const selectedAlertsLength = arrSelectedDeleteAlert.filter(i => arrAlertHolding.some(item => item.mktIdToken === i.mktIdToken)).length;
            dispatch(toastConfig({
                show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove Selected Alerts
                    <div className='set-alert-remove-count font-regular ms-2'>{`${selectedAlertsLength}`}</div>
                </div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: `${strClassName}`, bIsDisabled: arrSelectedDeleteAlert.length === 0 }]
            }));
        }
    }, [arrSelectedDeleteAlert, bShowDeleteCheckbox]);
    //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting - End
    const handleSelectAlertForDelete = (data) => {
        setSelectAllCheckbox(false);
        if (arrSelectedDeleteAlert.includes(data)) {
            setArrSelectedDeleteAlert(arrSelectedDeleteAlert.filter((i) => i !== data));
        } else {
            setArrSelectedDeleteAlert([...arrSelectedDeleteAlert, data]);
        }
    };

    const handleSelectAll = (e) => {
        const isSelected = e.target.checked === true;
        setSelectAllCheckbox(e.target.checked);
        // setArrSelectedDeleteAlert(isSelected ? [...arrAlerts] : []);
        if (isSelected) {
            if (AlertPortfolio) {
                setArrSelectedDeleteAlert(activeTab === 'alerts' ? [...arrAlertHolding] : [...arrAlertLogHolding]);
            } else {
                setArrSelectedDeleteAlert([...arrActiveAlerts]);
            }
        } else {
            setArrSelectedDeleteAlert([]);
        }
    };

    const handleALertDelet = () => {
        setDeleteAlertStep(DELETE_ALERT_STEP.CONFIRMATION);
    };
    //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
    const bINesperAlert = getAppInfoData(APP_INFO_PARAMS.APP_NESPER_ALERT);
    const handleConfirmDeleteAlert = () => {

        // if (bINesperAlert) {
        const arrPayload = arrSelectedDeleteAlert?.map((alert) => {
            return ({
                "condition": [
                    {
                        "operand1": {
                            "marketsegment": getMappedMktSegIdFromApiExchangeName(alert?.scripObj?.ExchangeSegment),
                            "token": alert.nToken,
                            "field": alert.factor1
                        },
                        "operand2": {
                            "marketsegment": getMappedMktSegIdFromApiExchangeName(alert?.scripObj?.ExchangeSegment),
                            "token": alert.nToken,
                            "field": alert.factor2,
                            "value": alert.amount
                        },
                        "operator": alert.operator
                    }
                ],
                "data": {
                    "remarks": "",
                    "userid": objLoginSession?.data?.user_id,
                    "tenantid": config.TenantId,
                    "symbol": alert.symbol,
                    "alertType": alert.alertType,
                    "category": alert.category
                },
                "expiration": alert.expiration,
                "createDate": alert.createDate,
                "tenantId": config.TenantId,
                "workerId": alert.workerId,
                "triggered": alert.triggered,
                "entryTime": alert.entryTime,
                "UCC": objLoginSession?.data?.user_id,
                "MessageType": "USR_ALERT",
                "serverAlertId": alert.serverAlertId,
                "UniqueId": alert.UniqueId,
                "time": Date.now(),
                "triggeredDate": "",
                "token": alert.nToken,
                "mktSegId": getMappedMktSegIdFromApiExchangeName(alert?.scripObj?.ExchangeSegment),
                "exchange": alert.scripObj.ExchangeSegment,
                "displayExchange": alert.exchange,
                "price": alert.amount,
                "alert": SET_ALERT_FIELDS.FACTOR1[alert.factor1]?.value,
                "comparator": alert.operator,
                "pricealert": SET_ALERT_FIELDS.FACTOR2[alert.factor2]?.value === 'USE_VALUE' ? alert.amount : SET_ALERT_FIELDS.FACTOR2[alert.factor2]?.value,
                "scripObj": alert.scripObj,
                "Series": alert.series,
                "displayScripDesc": ""
            });
        });

        dispatch(removeMultipleAlerts({ "data": arrPayload })).then((objResp) => {
            if (objResp?.data.status === "success") {
                setArrSelectedDeleteAlert([]);
                setDeleteAlertStep(DELETE_ALERT_STEP.DONE);
                setTimeout(() => {
                    dispatch(getAlerts(objLoginSession?.data?.user_id));
                }, 3000);

            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Alert(s) has been not deleted.', }));
            }
        });
        // Azeem K :20-03-2025 :  as per discussion with Norwin and Indresh Delete api is not using right now, for nesper and redis alert using deleteScripAlert post api so delete api code commented, code will remove later --Start
        // } else {
        //     arrSelectedDeleteAlert?.forEach((item) => {
        //         dispatch(removeAlert({ userID: objLoginSession?.data?.user_id, serverAlertId: item?.serverAlertId }));
        //     });
        //     setTimeout(() => {
        //         dispatch(getAlerts(objLoginSession?.data?.user_id));
        //     }, 3000);
        //     setDeleteAlertStep(DELETE_ALERT_STEP.DONE);
        //     setArrSelectedDeleteAlert([]);

        // }
        // Azeem K :20-03-2025 :  as per discussion with Norwin and Indresh Delete api is not using right now, for nesper and redis alert using deleteScripAlert post api so delete api code commented, code will remove later --End

    };
    //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End

    const handleDeleteSingleAlert = (data) => {
        //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting - Start
        if (AlertPortfolio) {
            setArrSelectedDeleteAlert([data]);
            dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'>Remove Selected Alerts <div className='notification-count font-regular mx-2'>01</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-light ms-3" }] }));
        }
        else {
            setArrSelectedDeleteAlert([data]);
            setDeleteAlertStep(DELETE_ALERT_STEP.CONFIRMATION);
        }
        //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting - End   
    };
    const handleDeleteAlertDone = () => {
        setDeleteAlertStep(DELETE_ALERT_STEP.ALERT_SELECTION);
        setBShowDeleteCheckbox(false);
    };
    const handleCloseDeleteAlert = () => {
        setBShowDeleteCheckbox(false);
        setArrSelectedDeleteAlert([]);

    };

    const handleBackFromDeleteAlert = () => {
        setDeleteAlertStep(DELETE_ALERT_STEP.ALERT_SELECTION);
        if (!bShowDeleteCheckbox) {
            setArrSelectedDeleteAlert([]);
        }
    };
    // const handlDropDownToggle = () => {
    //     dispatch(searchAlertByDropdown(arrFilterAlertAttributes));
    // };
    const handleToggleSearchBar = () => {
        //ManasaB : 13/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - AlertLog Issue - Start
        if (activeTab === 'alerts') {
            if (AlertPortfolio) {
                if (arrAlertHolding.length > 0) {
                    setBToggleSearchBar(!bToggleSearchBar);
                    setPropertyChange(!propertyChange);
                    dispatch(searchAlertBySymbol(''));
                }
            }
            else {
                if (arrAlerts.length > 0) {
                    setBToggleSearchBar(!bToggleSearchBar);
                    setPropertyChange(!propertyChange);
                    dispatch(searchAlertBySymbol(''));
                }
            }
        }
        if (activeTab === 'alertlog') {
            if (AlertPortfolio) {
                if (arrAlertLogHolding.length > 0) {
                    setBToggleSearchBar(!bToggleSearchBar);
                    setPropertyChange(!propertyChange);
                    dispatch(searchAlertBySymbol(''));
                }
            }
            else {
                if (trigerredAlerts.length > 0) {
                    setBToggleSearchBar(!bToggleSearchBar);
                    setPropertyChange(!propertyChange);
                    dispatch(searchAlertBySymbol(''));
                }
            }

        }
        //ManasaB : 13/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - AlertLog Issue - End
    };
    const handleSearchScripBySymbol = (e) => {
        dispatch(searchAlertBySymbol(e.target.value));
    };
    // const handleEventFilterChange = (e) => {
    //     if (arrFilterAlertAttributes.includes(e.target.value)) {
    //         setArrFilterAlertAttributes(arrFilterAlertAttributes?.filter((i) => i !== e.target.value));
    //     } else {
    //         setArrFilterAlertAttributes([...arrFilterAlertAttributes, e.target.value]);
    //     }
    // };
    const handleFilterEventDelete = (key) => {

        if (key === 'selectedCategory') {
            setSelectedCategory('');
        } else if (key === 'selectedAlerts') {
            setSelectedAlerts('');
        }

        dispatch(searchAlertByDropdown({ ...objFilterAlertFromModal, [key]: '' }));


    };
    const handleToggleAlert = () => {
        setActiveTab('alerts');
        setPropertyChange(false);
        if (activeTab !== 'alerts') {
            dispatch(searchAlertByDropdown({}));
            dispatch(searchAlertBySymbol(''));
            setBToggleSearchBar(true);
            setBShowDeleteCheckbox(false);
            setArrSelectedDeleteAlert([]);
            setSelectedCategory('');
            setSelectedAlerts('');

        }
    };
    const nTriggerAlertCountFromRedux = useSelector(state => state?.alerts?.nTriggerAlertCountFromRedux);

    const handleToggleAlertLog = () => {
        setActiveTab('alertlog');
        setPropertyChange(false);
        if (!AlertPortfolio) {
            dispatch(setTriggerAlertCount(nTriggerAlertCountFromRedux + 1));
            localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_ALERT_COUNT + objLoginSession?.data?.user_id, 0);

            // setEncryptLocalStorage('TRIGGER_ALERT_COUNT' + objLoginSession?.data?.user_id, 0);
        }
        if (activeTab !== 'alertlog') {
            dispatch(searchAlertByDropdown({}));
            dispatch(searchAlertBySymbol(''));
            setBToggleSearchBar(true);
            setBShowDeleteCheckbox(false);
            setArrSelectedDeleteAlert([]);
            setSelectedCategory('');
            setSelectedAlerts('');

        }
    };
    useEffect(() => {
        return (() => {
            dispatch(searchAlertByDropdown({}));
            dispatch(searchAlertBySymbol(''));
            setBToggleSearchBar(true);
            dispatch(toastConfig({})); //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting 
        });
    }, [dispatch]);
    //Vaibhav Singh : BT-117135- 20-09-2023 : Moved Nav tab to variables 
    //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting  - Start
    const handleToast = (type) => {
        switch (type) {
            case 'CLOSE': {
                dispatch(toastConfig({}));
                break;
            }
            case 'CLOSE_REMOVE_ALERT_TOASTER': {
                dispatch(toastConfig({ show: false }));
                setBShowDeleteCheckbox(false);
                setArrSelectedDeleteAlert([]);
                dispatch(handleModal([{ "DELETE_ALERT_SUCCESS_MODAL": false }, { "DELETE_ALERT_CONFIRM_MODAL": false }]));
                break;
            }
            case 'REMOVE_ALERT': {
                dispatch(handleModal([{ "DELETE_ALERT_CONFIRM_MODAL": true }]));
                break;
            }
            default: {
                break;
            }
        }
    };
    //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster in portfolio while deleting  - End

    // Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedAlerts, setSelectedAlerts] = useState('');

    const handleCategoryFilter = (alert) => {
        setSelectedCategory(alert);
    };

    const handlerAlertsFilter = (alert) => {
        setSelectedAlerts(alert);
    };

    const handleResetFilter = () => {
        setSelectedCategory('');
        setSelectedAlerts('');
        setIsShowFilterModal(false);
        dispatch(searchAlertByDropdown({}));
    };

    const handleApplyFilter = () => {
        dispatch(searchAlertByDropdown({ selectedCategory: selectedCategory, selectedAlerts: selectedAlerts }));
        setIsShowFilterModal(false);
    };
    // Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End

    const handleRefreshAlert = () => {
        if (objLoginSession?.data?.user_id) {
            dispatch(getAlerts(objLoginSession?.data?.user_id));
        }
    };

    const alertscrips = (
        <Container fluid className={`p-0 ${isVertical ? 'px-3' : ''}`}>
            <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                <Col md={4} className='d-flex justify-content-start align-self-center'>
                    <BzButton className='btn btn-outline btn-sm d-flex align-items-center gap-1 ms-1' disabled={bShowDeleteCheckbox}>
                        <div className='icon-12 icon-add-circle-fill icon-primary d-flex flex-shrink-0 me-1'></div>
                        <div className='font-medium font-size1' onClick={handleSetAlertShow}>Set Alert</div>
                    </BzButton>
                </Col>
                <Col md={8} className='d-flex align-items-center justify-content-end'>
                    {isVertical ? (bToggleSearchBar ?
                        <div className={`icon-16 icon-search flex-shrink-0 ${(AlertPortfolio && arrAlertHolding?.length <= 0) || (!AlertPortfolio && arrAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`} onClick={handleToggleSearchBar}></div> :
                        <>
                            <div className='position-relative w-70'>
                                <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                <BzInputText onChange={handleSearchScripBySymbol.bind(this)} size='sm' type='search' placeholder="Search Here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                            </div>
                            <div className='icon-16 icon-close icon-dark ms-2 flex-shrink-0' onClick={handleToggleSearchBar}></div>
                        </>
                    ) : null}
                    <div className={`icon-16 icon-searchfilter ms-2 flex-shrink-0 ${(AlertPortfolio && arrAlertHolding?.length <= 0) || (!AlertPortfolio && arrActiveAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`} onClick={() => (AlertPortfolio && arrAlertHolding?.length > 0) || (!AlertPortfolio && arrActiveAlerts?.length > 0) ? setIsShowFilterModal(true) : null}></div>
                    {AlertPortfolio || !isVertical ? <BzToolTip placement={'bottom'} TooltipMsg={'Refresh'}>
                        <div className='icon-16 icon-refresh background-textual-link-withicon mx-2 flex-shrink-0' onClick={handleRefreshAlert}></div>
                    </BzToolTip> : null}
                    <div className={`icon-16 icon-delete ${!AlertPortfolio ? 'ms-2' : ''} ${(AlertPortfolio && arrAlertHolding?.length <= 0) || (!AlertPortfolio && arrActiveAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`} onClick={showDeleteCheckbox}></div>
                </Col>
            </Row>
        </Container>);

    const alertLogScrips = (
        <Container fluid className={`p-0 ${isVertical ? 'px-3' : ''}`}>
            <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                <Col md={3} className='d-flex justify-content-start align-self-center'>
                    <div className='font-medium font-size1 color-subtext'>Triggered Alerts</div>
                </Col>
                <Col md={9} className='d-flex align-items-center justify-content-end'>
                    {isVertical ? (bToggleSearchBar ?
                        <div className={`icon-16 icon-search flex-shrink-0 ${(AlertPortfolio && arrAlertLogHolding?.length <= 0) || (!AlertPortfolio && trigerredAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`} onClick={handleToggleSearchBar}></div> :
                        <>
                            <div className='position-relative w-100'>
                                <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                <BzInputText onChange={handleSearchScripBySymbol.bind(this)} size='sm' type='search' placeholder="Search Here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                            </div>
                            <div className='icon-16 icon-dark icon-close ms-2 flex-shrink-0' onClick={handleToggleSearchBar} />
                        </>
                    ) : null}
                    {AlertPortfolio || !isVertical ? <BzToolTip placement={'bottom'} TooltipMsg={'Refresh'}>
                        <div className='icon-16 icon-refresh background-textual-link-withicon mx-2 flex-shrink-0' onClick={handleRefreshAlert}></div>
                    </BzToolTip> : null}
                    <div onClick={() => (AlertPortfolio && arrAlertLogHolding?.length > 0) || (!AlertPortfolio && arrActiveAlerts?.length > 0) ? setIsShowFilterModal(true) : null} className={`icon-16 icon-searchfilter ms-2 flex-shrink-0 ${(AlertPortfolio && arrAlertLogHolding?.length <= 0) || (!AlertPortfolio && arrActiveAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`} ></div>
                    {!bINesperAlert ?
                        <div onClick={showDeleteCheckbox} className={`icon-16 icon-delete ms-2 flex-shrink-0 ${(AlertPortfolio && arrAlertLogHolding?.length <= 0) || (!AlertPortfolio && arrActiveAlerts?.length <= 0) ? 'icon-grey' : 'icon-dark'}`}></div>
                        : null}
                </Col>
            </Row>
        </Container>);
    return (
        <>

            {deleteAlertStep === DELETE_ALERT_STEP.ALERT_SELECTION ?
                <Container fluid className='p-0'>
                    {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start */}
                    {AlertPortfolio && <BzToastMessage btnClickHandler={handleToast} />}
                    {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End */}
                    <ContainerHeader>
                        {(!AlertPortfolio && isVertical) ?
                            <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                                <Col md={9} className='d-flex justify-content-start align-items-center'>
                                    <div className='d-inline-flex align-items-center'>
                                        <span className='font-medium font-size5 color-text text-uppercase line-height-1 d-flex align-items-center pt-1'>ALERTS</span>
                                        <BzToolTip placement={'bottom'} TooltipMsg={'Refresh'}>
                                            <div className='icon-16 icon-refresh background-textual-link-withicon d-inline-flex flex-shrink-0 ms-2' onClick={handleRefreshAlert}></div>
                                        </BzToolTip>
                                    </div>
                                </Col >
                                <Col md={3} className='d-flex justify-content-end align-self-center'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                        <div className='icon-16 icon-dark icon-close ms-3' onClick={() => {
                                            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                            setToggleSideContainer(false);
                                            setActiveMenu({});
                                        }}>
                                        </div>
                                    </BzToolTip>
                                </Col>
                            </Row >
                            : null}
                        <Row className={`g-0 my-2 ${isVertical ? 'px-3' : ''}`}>
                            <Col>
                                <div className='horizontal-scroll-wrap d-flex'>
                                    <BzTabs className='nav nav-tabs'>
                                        <BzTab className='nav-link text-capitalize' onClick={handleToggleAlert} isActive={activeTab === 'alerts'} tabKey='alerts'>Pending({(AlertPortfolio) ? arrAlertHolding?.length : isVertical === false ? arrAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length : arrAlerts?.length})</BzTab>
                                        <BzTab className='nav-link text-capitalize' onClick={handleToggleAlertLog} isActive={activeTab === 'alertlog'} tabKey='alertlog'>Triggered({(AlertPortfolio) ? arrAlertLogHolding?.length : isVertical === false ? trigerredAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length : trigerredAlerts?.length})</BzTab>
                                    </BzTabs>
                                    {/* Vaibhav Singh : BT-117135- 22-09-2023 : css For SideAlert Working in Portfolio as per discussion with  Hari  */}

                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                {
                                    (AlertPortfolio) ?
                                        activeTab === 'alerts' ?
                                            <div className={(propertyChange) ? '' : ''}>
                                                {alertscrips}
                                            </div>
                                            : (
                                                activeTab === 'alertlog' ?
                                                    <div className={(propertyChange) ? '' : ''}>
                                                        {alertLogScrips}
                                                    </div>
                                                    : null
                                            )
                                        : null
                                }
                            </Col>
                        </Row>
                        {
                            (!AlertPortfolio) ?
                                activeTab === 'alerts' ?
                                    alertscrips
                                    : (
                                        activeTab === 'alertlog' ?
                                            alertLogScrips
                                            : null
                                    )
                                : null
                        }
                        {
                            (objFilterAlertFromModal?.selectedCategory || objFilterAlertFromModal?.selectedAlerts) &&
                            <Row className='g-0 mx-3 mb-2'>
                                <Col md={12}>
                                    <div className='d-flex'>
                                        <div className='font-medium font-size3 color-text me-2'>Filters:</div>
                                        <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                            {objFilterAlertFromModal?.selectedCategory && <BzChip className='filter-chip me-1 text-capitalize'>{ALERT_CATEGORIES[objFilterAlertFromModal?.selectedCategory] ? ALERT_CATEGORIES[objFilterAlertFromModal?.selectedCategory] : objFilterAlertFromModal?.selectedCategory}<div className='icon-10 icon-close icon-dark ms-2' onClick={handleFilterEventDelete.bind(this, 'selectedCategory')}></div></BzChip>}
                                            {objFilterAlertFromModal?.selectedAlerts && <BzChip className='filter-chip me-1 text-capitalize'> {SET_ALERT_FIELDS.FACTOR1[objFilterAlertFromModal?.selectedAlerts]?.value ? SET_ALERT_FIELDS.FACTOR1[objFilterAlertFromModal?.selectedAlerts]?.value : objFilterAlertFromModal?.selectedAlerts}<div className='icon-10 icon-close icon-dark ms-2' onClick={handleFilterEventDelete.bind(this, 'selectedAlerts')}></div></BzChip>}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        }
                    </ContainerHeader >
                    <ContainerBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                {bShowDeleteCheckbox && <Col md={12}>
                                    <div className='d-flex align-items-center gap-1 ms-2 py-2'>
                                        <input type="checkbox" className='form-check-input' checked={selectAllCheckbox} onChange={handleSelectAll} />
                                        <div className='font-medium font-size2 color-text'>SELECT ALL</div>
                                    </div>

                                </Col>}
                                <Col>
                                    {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */}
                                    <Alerts isVertical={isVertical} selectAllCheckbox={selectAllCheckbox} selectedCategory={selectedCategory} selectedAlerts={selectedAlerts} setSelectedAlerts={setSelectedAlerts} setSelectedCategory={setSelectedCategory} AlertPortfolio={AlertPortfolio} arrAlertAttributes={arrAlertHolding} arrAlertLogAttributes={arrAlertLogHolding} activeTab={activeTab} bShowDeleteCheckbox={bShowDeleteCheckbox} handleALertDelet={handleALertDelet} handleCloseDeleteAlert={handleCloseDeleteAlert} setActiveTab={setActiveTab} handleSelectAlertForDelete={handleSelectAlertForDelete} arrSelectedDeleteAlert={arrSelectedDeleteAlert} handleDeleteSingleAlert={handleDeleteSingleAlert} />
                                    {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End */}
                                </Col>
                            </Row>
                        </Container>
                    </ContainerBody>
                    {bShowDeleteCheckbox && !AlertPortfolio && //ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 
                        <ContainerFooter>
                            <div className='p-3 bdr-top'>
                                <Row className='g-0 mb-3'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='font-regular font-size3 color-text me-2'>Remove Selected Alerts</div>
                                        <div className='set-alert-remove-count font-regular ms-2'>{`${arrSelectedDeleteAlert?.length < 10 && arrSelectedDeleteAlert?.length !== 0 ? (`0 ${arrSelectedDeleteAlert?.length}`) : arrSelectedDeleteAlert?.length}`}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-1'>
                                    <Col className='pe-2'>
                                        <BzButton className='btn btn-md btn-outline btn-block' onClick={handleCloseDeleteAlert}>CLOSE</BzButton>
                                    </Col>
                                    <Col className='ps-2'>
                                        <BzButton className='btn btn-md btn-primary btn-block' onClick={handleALertDelet} disabled={arrSelectedDeleteAlert?.length === 0} >REMOVE ALERT</BzButton>
                                    </Col>
                                </Row>
                            </div>
                        </ContainerFooter>    //Hari P: 12-11-2023 SAT-BT-107432 2nd Cycle  UI issue fixed                           
                    }
                </Container>
                : deleteAlertStep === DELETE_ALERT_STEP.CONFIRMATION ?
                    <Container fluid className='p-0'>
                        <ContainerHeader>
                            <Row className='g-0 bdr-btm py-2 px-3'>
                                <Col className='d-flex justify-content-start align-items-center py-1' onClick={handleBackFromDeleteAlert}>
                                    <div className='icon-14 icon-backward-arrow icon-dark me-3'></div>
                                    <BzHeading className='font-medium font-size5 color-text'>Remove Alert</BzHeading>
                                </Col>
                            </Row>
                        </ContainerHeader>
                        <ContainerBody>
                            <Row className='g-0'>
                                <Col className='p-3'>
                                    {/* ManasaB : 15/11/2023 : BT-115821 : Alerts SAT Issue Resolve  - added /s to below message */}
                                    <div className='font-regular font-size4 color-text pb-3'>Are you sure you want to remove the following alert/s?</div>
                                    {
                                        arrSelectedDeleteAlert?.map((item) => {
                                            return (
                                                <Row className='g-0 mb-2'>
                                                    <Col>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='font-medium font-size4 color-text text-uppercase'>{item?.symbol}</div>
                                                            <div className='chips-wrap px-2'>
                                                                <BzChip className='exchange-chip text-capitalize'>{item?.exchange}</BzChip>
                                                            </div>
                                                            <AlertNameDetails alertData={item} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            );
                                        })
                                    }
                                </Col>
                            </Row>
                        </ContainerBody>
                        <ContainerFooter>
                            <div className='g-0 p-3 bdr-top'>
                                {bShowDeleteCheckbox &&
                                    <Row className='g-0 mb-3'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='font-regular font-size3 color-text me-2'>Remove Selected Alerts</div>
                                            <div className='set-alert-remove-count font-regular ms-2'>{`${arrSelectedDeleteAlert?.length < 10 && arrSelectedDeleteAlert?.length !== 0 ? '0' + arrSelectedDeleteAlert?.length : arrSelectedDeleteAlert?.length}`}</div>
                                        </Col>
                                    </Row>}
                                <Row className='g-0'>
                                    <Col>
                                        <BzButton className='btn btn-md btn-primary btn-block' onClick={handleConfirmDeleteAlert}>REMOVE ALERT</BzButton>
                                    </Col>
                                </Row>
                            </div>

                        </ContainerFooter>
                    </Container>
                    :
                    deleteAlertStep === DELETE_ALERT_STEP.DONE ?
                        <Container fluid className='p-0 h-100 alert-success'>
                            <ContainerBody>
                                <DeleteAlertSuccessfull strMessage={activeTab === 'alerts' ? SUCCESSFULL_DELETE_ALERET_MESSAGE.ACTIVE_ALERT : SUCCESSFULL_DELETE_ALERET_MESSAGE.TRIGGERED_ALERT} />
                            </ContainerBody>
                            <ContainerFooter>
                                <Row className={`g-0  ${isVertical ? 'mt-5' : 'mt-2'}  bdr-top`}>
                                    <Col className='p-3'>
                                        <BzButton className='btn btn-md btn-primary btn-block' onClick={handleDeleteAlertDone}>DONE</BzButton>
                                    </Col>
                                </Row>
                            </ContainerFooter>
                        </Container>

                        : null
            }
            {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 : Adding toaster while deleting - Start */}
            <DeleteAlertConfirmModal arrSelectedDeleteAlert={arrSelectedDeleteAlert} setArrSelectedDeleteAlert={setArrSelectedDeleteAlert} />
            <BzModal show={modals['DELETE_ALERT_SUCCESS_MODAL']} >
                <BzModalBody>
                    <DeleteAlertSuccessfull strMessage={activeTab === 'alerts' ? SUCCESSFULL_DELETE_ALERET_MESSAGE.ACTIVE_ALERT : SUCCESSFULL_DELETE_ALERET_MESSAGE.TRIGGERED_ALERT} />
                </BzModalBody>
            </BzModal>
            {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */}
            <SideAlertsFiltersModal selectedCategory={selectedCategory} selectedAlerts={selectedAlerts} applyReset={handleResetFilter} applyFilter={handleApplyFilter} isShow={isShowFilterModal} setIsShow={setIsShowFilterModal} handleCategoryFilter={handleCategoryFilter} handlerAlertsFilter={handlerAlertsFilter} arrActiveAlerts={arrActiveAlerts} />
            {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End */}
            {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3: Adding toaster while deleting - End */}
        </>

    );

};

export default memo(SideAlerts);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End
